import { Box } from '@mui/material'
import React from 'react'
import { Color, FontStyle } from '../constants'

const styles = {
    container: {
        ...FontStyle.body,
        borderRadius: '8px',
        padding: '4px 8px',
        fontSize: '12px',
        userSelect: 'none',
    },
    blueContainer: {
        backgroundColor: '#A29BFF',
        border: `3px solid #5B4FFF`,
        color: '#2D2880',
    },
    greenContainer: {
        backgroundColor: Color.mainGreen,
        border: `3px solid ${Color.darkGreen}`,
        color: '#00A629',
    },
    goldContainer: {
        background: 'radial-gradient(ellipse farthest-corner at right bottom, #FEDB37 0%, #FDB931 8%, #9f7928 30%, #8A6E2F 40%, transparent 80%), radial-gradient(ellipse farthest-corner at left top, #FFFFFF 0%, #FFFFAC 8%, #D1B464 25%, #5d4a1f 62.5%, #5d4a1f 100%)',
        border: `3px solid #000`,
        color: '#000',
    }
}

const ExpChip = ({ roleToken, experienceLevel }) => {
    return (
        experienceLevel > 0 ?
            <Box sx={{ ...styles.container, ...styles.blueContainer, minWidth: 'fit-content' }}>
                EXP: {Array.from(Array(3).keys()).map((_, i) => <span key={i}>{i < experienceLevel ? '★' : '☆'}</span>)}
                {/* EXP: {⭐️ for each experienceLevel} */}
            </Box>
            : roleToken === 'Gig Work' ?
                <Box sx={{ ...styles.container, ...styles.greenContainer }}>
                    💸 FAST 💸
                </Box>
                : experienceLevel === 0 ?
                    <Box sx={{ ...styles.container, ...styles.goldContainer }}>
                        INTERNSHIP
                    </Box>
                    : null
    )
}

export default ExpChip